import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocale } from "./i18n";
import { STRINGS } from "./i18n/strings";
import HeroComponent from "./components/hero/HeroComponent";
import ProblemSection from "./components/problemSection/ProblemSection";
import ProofSection from "./components/proofSection/ProofSection";
import AboutMeComponent from "./components/aboutMeComponent/AboutMeComponent";
import ContactComponent from "./components/contactComponent/ContactComponent";

const SITE = "https://www.danielrayrangel.com";

const HomePage = () => {
  const locale = useLocale();
  const meta = STRINGS[locale].meta;
  const url = locale === "es" ? `${SITE}/es` : `${SITE}/`;

  return (
    <>
      <Helmet htmlAttributes={{ lang: locale }}>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />

        <link rel="canonical" href={url} />
        <link rel="alternate" hrefLang="en" href={`${SITE}/`} />
        <link rel="alternate" hrefLang="es" href={`${SITE}/es`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE}/`} />

        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:url" content={url} />
        <meta property="og:locale" content={locale === "es" ? "es_US" : "en_US"} />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
      </Helmet>

      <HeroComponent />
      <ProblemSection />
      <ProofSection />
      <AboutMeComponent />
      <ContactComponent />
    </>
  );
};

export default HomePage;
